<div class="vzc-successfully-verified">
  <h1 class="vzc-successfully-verified__heading" i18n="@@S_ACCOUNT_ACTIVATION_SUCCESSFULLY_VERIFIED_HEADING">
    Successfully verified your account and set up your password
  </h1>

  <a
    mat-flat-button
    class="vzc-successfully-verified__proceed-btn"
    color="accent"
    [href]="revealUrl"
    i18n="@@S_CAP_ACCOUNT_ACTIVATION_PROCEED_TO_LOGIN"
  >
    PROCEED TO LOGIN
  </a>
</div>
